import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema3/GLB_BolsaBasura.glb"
import { GUI } from "dat.gui";
import gsap from "gsap";

export class BolsaBasura extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Bolsa_Basura002 = gltf.scene.getObjectByName("Bolsa_Basura002", true);
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Bolsa");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale X");
		premiaFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale Y");
		premiaFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale Z");
		premiaFolder.add(this, "visible").name("Visible");
	}

	onClearAnimation() {
		if (this.animation) {
			this.Bolsa_Basura002.material.emissiveIntensity = 1
			this.Bolsa_Basura002.material.emissive.set("#000000");
			this.animation.kill();
			this.animation = null
		}
	}

	onAnimateEmissive() {
		this.onClearAnimation()

		this.Bolsa_Basura002.material.emissive.set("#404040");

		this.animation = gsap.to(this.Bolsa_Basura002.material, {
			emissiveIntensity: 2,
			yoyo: true,
			repeat: -1,
			duration: 0.9,
			ease: "power1.inOut",
		});
	}

	renderAnimations() { }
}
